import { useRef, useEffect } from 'react';
import classNames from 'classnames/bind';
import gsap from 'gsap';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const S02 = () => {
  const containerRef = useRef();
  const featuresRef = useRef();

  useEffect(() => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          scrub: true,
          start: 'center center',
          end: 'bottom center',
        },
      })
      .fromTo(featuresRef.current, { opacity: 0 }, { opacity: 1 });
  }, []);

  return (
    <section ref={containerRef} className={cx('wrapper')}>
      <h1 className={cx('title')}>LEVRAI COSMETICS</h1>
      {/* <img src={require('../../../asset/images/global/logo_white.png')} alt="LEVRAI" /> */}
      <p className={cx('desc')}>
        “LE VRAI” means “The True” in French.
        <br />
        We focus on what truly matters —
        <br />
        thoughtful products your whole family can trust and enjoy.
      </p>
      <ul ref={featuresRef} className={cx('features')}>
        <li>SAFE</li>
        <li>SASSY</li>
        <li>SIMPLE</li>
      </ul>
    </section>
  );
};

export default S02;
